// Auto-generated by @semilayer/codegen — do not edit

import { BeamClient, type BeamConfig } from '@semilayer/client'
import { TicksLens, WildFactsLens, RemovalTechniquesLens, StatesLens, CountiesLens, DiseasesLens, TickStateLens, TickCountyLens, DiseaseCountyYearLens, PathogensLens, PathogenCountyLens, DiseaseMonthLens, TickDiseasesLens, TickPathogensLens, DiseasePathogensLens, TickRemovalTechniquesLens, WildFactTicksLens, WildFactDiseasesLens, WildFactRemovalTechniquesLens } from './lenses.js'

export class Beam {
  readonly ticks: TicksLens
  readonly wildFacts: WildFactsLens
  readonly removalTechniques: RemovalTechniquesLens
  readonly states: StatesLens
  readonly counties: CountiesLens
  readonly diseases: DiseasesLens
  readonly tickState: TickStateLens
  readonly tickCounty: TickCountyLens
  readonly diseaseCountyYear: DiseaseCountyYearLens
  readonly pathogens: PathogensLens
  readonly pathogenCounty: PathogenCountyLens
  readonly diseaseMonth: DiseaseMonthLens
  readonly tickDiseases: TickDiseasesLens
  readonly tickPathogens: TickPathogensLens
  readonly diseasePathogens: DiseasePathogensLens
  readonly tickRemovalTechniques: TickRemovalTechniquesLens
  readonly wildFactTicks: WildFactTicksLens
  readonly wildFactDiseases: WildFactDiseasesLens
  readonly wildFactRemovalTechniques: WildFactRemovalTechniquesLens

  constructor(config: BeamConfig) {
    const client = new BeamClient(config)
    this.ticks = new TicksLens(client)
    this.wildFacts = new WildFactsLens(client)
    this.removalTechniques = new RemovalTechniquesLens(client)
    this.states = new StatesLens(client)
    this.counties = new CountiesLens(client)
    this.diseases = new DiseasesLens(client)
    this.tickState = new TickStateLens(client)
    this.tickCounty = new TickCountyLens(client)
    this.diseaseCountyYear = new DiseaseCountyYearLens(client)
    this.pathogens = new PathogensLens(client)
    this.pathogenCounty = new PathogenCountyLens(client)
    this.diseaseMonth = new DiseaseMonthLens(client)
    this.tickDiseases = new TickDiseasesLens(client)
    this.tickPathogens = new TickPathogensLens(client)
    this.diseasePathogens = new DiseasePathogensLens(client)
    this.tickRemovalTechniques = new TickRemovalTechniquesLens(client)
    this.wildFactTicks = new WildFactTicksLens(client)
    this.wildFactDiseases = new WildFactDiseasesLens(client)
    this.wildFactRemovalTechniques = new WildFactRemovalTechniquesLens(client)
  }
}

export function createBeam(config: BeamConfig): Beam {
  return new Beam(config)
}
